import React from 'react';
import { Box, Typography } from '@mui/material';

interface SectionLabelProps {
  children: React.ReactNode;
  align?: 'left' | 'center';
  light?: boolean; // true = on dark background (default), false = on light background
}

// Small uppercase eyebrow with a short brand bar — a consistent
// industrial section marker used across the site.
const SectionLabel: React.FC<SectionLabelProps> = ({
  children,
  align = 'center',
  light = true,
}) => (
  <Box
    sx={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: align === 'center' ? 'center' : 'flex-start',
      gap: 1.5,
      mb: 2,
    }}
  >
    <Box sx={{ width: 34, height: 3, background: '#e11414', borderRadius: 2 }} />
    <Typography
      variant="overline"
      sx={{
        color: light ? 'rgba(255,255,255,0.7)' : 'rgba(0,0,0,0.55)',
        fontSize: '0.8rem',
        lineHeight: 1,
      }}
    >
      {children}
    </Typography>
  </Box>
);

export default SectionLabel;
